import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Organization } from '../types/organization.type';
import { ADMIN_ORGANIZATIONS_API_PATHS } from '../constants/organizations-paths.constants';

type UpdateOrganizationMembersParams = {
  organizationId: string;
  members: {
    add?: string[];
    remove?: string[];
  };
};

type UseUpdateOrganizationMembersResult = {
  isUpdating: boolean;
  updateOrganizationMembers: (params: UpdateOrganizationMembersParams) => Promise<Organization | null>;
};

export function useUpdateOrganizationMembers(): UseUpdateOrganizationMembersResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isUpdating, setIsUpdating] = useState(false);

  const updateOrganizationMembers = async (
    params: UpdateOrganizationMembersParams
  ): Promise<Organization | null> => {
    setIsUpdating(true);

    try {
      const updatedOrganization = await HttpClient.patch<Organization>(
        ADMIN_ORGANIZATIONS_API_PATHS.UPDATE_ORGANIZATION(params.organizationId),
        params
      );

      return updatedOrganization;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, "Une erreur est survenue lors de la mise à jour des membres de l'organisation"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsUpdating(false);
    }
  };

  return { isUpdating, updateOrganizationMembers };
}
